import { DevChatFrontendToolBase } from './DevChatFrontendToolBase';

export class GetTimeFrontendTool extends DevChatFrontendToolBase {
  static get toolId() {
    return 'get_time';
  }

  static get description() {
    return 'Returns the current date and time from the Dev Chat host (ISO 8601 plus a local string).';
  }

  static get paramsSchema() {
    return {
      type: 'object',
      properties: {},
    };
  }

  async execute() {
    const now = new Date();
    return {
      iso: now.toISOString(),
      local: now.toString(),
    };
  }

  static formatBubbleSummary(result) {
    if (result && typeof result === 'object' && 'iso' in result) {
      const r = /** @type {{ iso?: string, local?: string }} */ (result);
      const iso = r.iso || '';
      const local = r.local || iso;
      return `Current time: ${local} (${iso})`;
    }
    return super.formatBubbleSummary(result);
  }
}
